<template>
  <div class="thread-base-container">
    <el-dialog title="请填写帖子基本信息" :visible.sync="dialogVisible">
      <div class="">
        <div class="list-box">
          <label class="label inline-block">新版帖子频道：</label>
          <span class="select">
            <select v-model="model.tabId">
              <option v-for="(item,index) in initModuleList.tabList" :value="item.tabId">{{item.tabName}}</option>
            </select>
          </span>
          <span class="red-font">*必填</span>
        </div>
        <div class="list-box">
          <label class="label inline-block">标题：</label>
          <input  class="input" v-model="model.title" type="text" style="width: 400px">
          <span class="red-font">*必填</span>
        </div>
        <div class="list-box">
          <label class="label inline-block">帖子类型：</label>
          <span class="select">
                <select v-model="model.type">
                  <option v-for="(item,index) in initModuleList.typeList" :value="item.typeId" >{{item.typeName}}</option>
              </select>
              </span>
        </div>
        <div class="list-box clearfix">
          <label class="label fleft inline-block">发布用户：</label>
          <el-select v-model="model.publishUserId" filterable placeholder="请选择发布人">
            <el-option
              v-for="(item,index) in initModuleList.publishUserList"
              :key="item.userId"
              :label="item.username"
              :value="item.userId">
            </el-option>
          </el-select>
          <span class="red-font">*必填</span>
        </div>
        <div class="list-box">
          <label class="label inline-block">定时发帖：</label>
          <el-date-picker
            v-model="model.timeSet"
            type="datetime"
            placeholder="选择日期时间">
          </el-date-picker>
          <input type="checkbox" v-model="model.isSetTime">展示
        </div>
        <div class="list-box">
          <label class="label inline-block">评论是否全部展示：</label>
          <input type="radio" name="replyStyle" v-model="model.replyStyle" value="1">是
          <input type="radio" name="replyStyle" v-model="model.replyStyle" value="0">否
        </div>
        <div class="list-box">
          <label class="label inline-block">是否展示相关推荐：</label>
          <input type="radio" name="showRelatedRecommend" v-model="model.showRelatedRecommend" value="1">是
          <input type="radio" name="showRelatedRecommend" v-model="model.showRelatedRecommend" value="0">否
        </div>
        <div class="list-box clearfix">
          <label class="label fleft inline-block">帖子标签：</label>
          <el-select v-model="model.tagIds" multiple filterable placeholder="请选择标签">
            <el-option
              v-for="(item,index) in initModuleList.tags"
              :key="item.id"
              :label="item.nameNew"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="list-box">
          <label class="label inline-block">推荐到首页：</label>
          <el-date-picker
            v-model="model.homeTime"
            type="datetime"
            placeholder="推荐到首页">
          </el-date-picker>
        </div>
        <div class="list-box clearfix">
          <label class="label fleft inline-block">添加到栏目：</label>
          <el-select v-model="model.columns" multiple filterable placeholder="请选择栏目">
            <el-option
              v-for="(item,index) in initModuleList.columnList"
              :key="item.columnId"
              :label="item.columnName"
              :value="item.columnId">
            </el-option>
          </el-select>
        </div>
        <div class="list-box">
          <label class="label inline-block">是否在栏目中推荐：</label>
          <input type="radio" name="recommendInColumn" v-model="model.recommendInColumn" value="1">是
          <input type="radio" name="recommendInColumn" v-model="model.recommendInColumn" value="0">否
        </div>
        <div class="list-box">
          <label class="label inline-block">(旧版)截止日期：</label>
          <el-date-picker
            v-model="model.endTime"
            type="datetime"
            placeholder="选择日期时间">
          </el-date-picker>
          <span>(到截止日期之后自动不再展示在首页)
                <input type="radio" name="autoHidden" v-model="model.autoHidden" value="1">是
               <input type="radio" name="autoHidden" v-model="model.autoHidden" value="0">否
              </span>
          <span class="red-font">*必填</span>
        </div>
        <div class="list-box">
          <label class="label inline-block">(旧版)不展示在社区首页：</label>
          <input type="radio" name="showInHotList" v-model="model.showInHotList" value="1">是
          <input type="radio" name="showInHotList" v-model="model.showInHotList" value="0">否
        </div>
        <div class="list-box">
          <label class="label inline-block">手动推荐帖子id：</label>
          <textarea class="textarea" v-model="model.manualRecommends" placeholder="请输入要推荐的帖子Id,用逗号隔开,最多推荐五个"></textarea>
        </div>
        <div class="list-box">
          <label class="label inline-block">内容摘要：</label>
          <textarea class="textarea" v-model="model.brief"></textarea>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="MODAL_OK_EVENT">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script type="text/babel">
import Uploader from 'COMMON/uploaderModule/uploader'
import {formatDate} from 'UTILS/date'

export default {
  watch: {
    messageTitle () {
      this.model.title = this.messageTitle
    }
  },
  props: {
    messageTitle: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      coverImageSrc: '', // 封面图
      topImageSrc: '', // 顶部图
      initModuleList: {
        columnList: [],
        publishUserList: [],
        tabList: {},
        tags: [],
        typeList: {}
      },
      model: {
        accountNumber: '', // 公众号id
        fileId: '', // 公众号文章id
        msgId: '', // 公众号文章id
        title: '',
        tabId: 0,
        type: 0,
        isSetTime: 0,
        timeSet: '',
        endTime: '',
        publishUserId: '',
        //          coverImage:{
        //            image: "",
        //            width: 0,
        //            height: 0
        //          },
        isShow: 0,
        autoHidden: 0,
        showInHotList: 0,
        //          topImage:{
        //            image: "",
        //            width: 81,
        //            height: 81
        //          },
        replySort: 0,
        recommendInColumn: 0,
        columns: [],
        manualRecommends: [],
        replyStyle: 0,
        showRelatedRecommend: 0,
        brief: '',
        tagIds: [],
        homeTime: ''
      },
      dialogVisible: false
    }
  },
  mounted () {
    // 暂时去掉手动上传封面图功能
    //      this.initBindUploadImageClick();
  },
  methods: {
    showModal () {
      this.getThreadInit()
      this.model.title = this.messageTitle
      this.dialogVisible = true
    },
    // 确认点击
    MODAL_OK_EVENT () {
      if (this.model.manualRecommends.length > 0) {
        this.model.manualRecommends = this.model.manualRecommends.replace(/\s/g, '').split(',')
      }
      if (!this.model.tabId) {
        this.$message('请选择频道')
        return false
      }
      if (!this.model.publishUserId) {
        this.$message('请选择发布人')
        return false
      }
      if (!this.model.title) {
        this.$message('请填写标题')
        return false
      }
      if (!this.model.endTime) {
        this.$message('请选择截止时间')
        return false
      }
      this.dialogVisible = false
      this.model.timeSet = this.model.timeSet ? formatDate(new Date(this.model.timeSet).getTime(), 'yyyy-MM-dd hh:mm') : ''
      this.model.endTime = formatDate(new Date(this.model.endTime).getTime(), 'yyyy-MM-dd hh:mm')
      this.model.homeTime = this.model.homeTime ? formatDate(new Date(this.model.homeTime).getTime()) : ''
      this.$emit('do-save-tread-event', this.model)
    },
    initBindUploadImageClick: function () {
      this.uploadMainBind('#js_topImageBtn', (response) => {
        this.model.topImage.image = response.images.info.path
        this.model.topImage.height = response.images.info.height
        this.model.topImage.width = response.images.info.width
        this.topImageSrc = this.model.topImage.image
      })
      this.uploadMainBind('#js_coverImgBtn', (response) => {
        this.model.coverImage.image = response.images.info.path
        this.model.coverImage.height = response.images.info.height
        this.model.coverImage.width = response.images.info.width
        this.coverImageSrc = this.model.coverImage.image
      })
    },
    getThreadInit () {
      HttpRequest.post('/admin.php?method=wechat.getThreadInit', true).then((response) => {
        this.initModuleList.tabList = response.data.tabList
        this.initModuleList.typeList = response.data.typeList
        this.initModuleList.publishUserList = _.toArray(response.data.publishUserList)
        this.initModuleList.columnList = _.toArray(response.data.columnList)
        _.each(response.data.tags, (item, index) => {
          _.each(item.tags, (tags, i) => {
            let data = {
              name: tags.name,
              id: tags.id,
              groupName: item.name,
              groupId: item.id,
              nameNew: '[' + item.name + ']' + tags.name
            }
            this.initModuleList.tags.push(data)
          })
        })
      }, (response) => {})
    },
    uploadMainBind (id, callBack) {
      // 绑定上传图片控件
      let params = {
        config: {
          pick: {
            id: id,
            multiple: false
          },
          server: process.env.VUE_APP_PLATFORM + '/admin.php?method=image.uploadImage',
          fileVal: 'image'
        },
        extensionField: {
          target: this
        },
        events: {
          onFilesQueued (files, uploaderObj) {
            return this.onFilesQueued && this.onFilesQueued(files, uploaderObj)
          },
          onSuccess (response, file, uploaderObj) {
            callBack && callBack(response.data)
          }
        }
      }
      new Uploader(params)
    }
  }
}
</script>
<style lang="less">
  .red-font{
    color: #ff0000;
  }
  .modal-ct{
    width: 800px !important;
  }
  .modal-ct .modal-ct-body{
    max-height: 600px !important;
  }
  .thread-base-container{
  .list-box{
    margin-bottom: 10px;
  }
  .img-wrap{
    margin-top: 20px;
  }
  textarea{
    width: 500px;
    min-width: 500px;
  }
  }
</style>
